    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
            company: null,
            companyFree: null,
            urlFree: null,
            companyNumber: 0
        }
    }
    
    const state = getDefaultState()

    const getters = {
        company: state => {
            return state.company
        },
        companyFree: state => {
            return state.companyFree
        },
        companyNumber: state => {
            return state.companyNumber
        },
        urlFree: state => {
            return state.urlFree
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        company: (state, payload) => {
            state.company = payload
        },
        companyFree: (state, payload) => {
            state.companyFree = payload
        },
        companyNumber: (state, payload) => {
            state.companyNumber = payload
        },
        urlFree: (state, payload) => {
            state.urlFree = payload
        },
    }

    const actions = {
       
        getCompany: ({commit, dispatch}) =>{
            commit('shiftUpdated', null)
            commit('updating', true)
            axiosAuth.get('/companies/mycompany')
            .then(
                res => {
                    commit('updating', false)
                    if(!res.data.message){
                        commit('company', res.data)
                    }
                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                    if(error.response){
                        if(error.response.status == 401) dispatch('logout')
                    }
                }
              )
        },

        getNumberCompany: ({commit}) =>{
            axiosAuth.get('/companies/number')
            .then(
                res => {
                    commit('companyNumber', res.data)
                }
              )
              .catch(
                () => {}
              )
        },

        postCompany ({commit, dispatch}, payload) {
            commit('updating', true)
            axiosAuth.post('/companies', payload)
                .then(
                    res => {
                        commit('trash', res)
                        commit('updating', false)
                        dispatch('userInformations')
                        dispatch('getCompany')
                    }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
                )
        },

        addFunds ({commit, dispatch}, payload) {
            commit('updating', true)
            axiosAuth.post('companies/addfunds', payload)
                .then(
                    res => {
                        commit('trash', res)
                        commit('updating', false)
                        dispatch('getCompany')
                    }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
                )
        },

        checkCompany: ({commit}, payload) =>{
            commit('updating', true)
            axiosAuth.get('/companies/checkname/' + payload.name)
            .then(
                res => {
                    commit('trash', res)
                    commit('updating', false)
                    if(!res.data){
                        commit('companyFree', true)
                    }else{
                        commit('companyFree', false)
                    }
                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                }
              )
        },

        checkUrl: ({commit}, payload) =>{
            axiosAuth.get('/companies/checkurl/' + payload.name)
            .then(
                res => {
                    commit('trash', res)
                    commit('urlFree', true)
                }
              )
              .catch(
                () => {
                  commit('urlFree', false)
                }
              )
        },

        blockOrderSlot: ({commit, dispatch}, payload) => {
            commit('updating', true)
            axiosAuth.patch('/companies/orderSlot', payload.data)
            .then(
                () => {
                    dispatch('getCompany')
                }
              )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },

        updateCompany: ({commit, dispatch}, payload) => {
           
            commit('updating', true)
            axiosAuth.patch('/companies/'+ payload._id, payload.data)
            .then(
                res => {
                    commit('trash', res)
                    commit('updating', false)
                    dispatch('getCompany')
                }
              )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        }
    }

    export default {
        state,
        getters,
        mutations,
        actions
    }